const makeSlug = (str) => str.replace(/\s+/g, "-")

export default makeSlug
